// ── Turnover package data (2026-09-24) ───────────────────────────────────────
// Turns one sp_GetTurnoverDetail row into the object buildTurnoverPackageHtml
// (src/utils/turnoverPrint.js) renders — the same shape TurnoverDetail passes
// when it prints / emails the package, so the in-app package page
// (/turnover/:id/package) shows exactly what the package holds. Pure.
import { sectionNumberOf } from "../../config/turnoverLayout";
import { normalizeKickoff } from "../../config/marketingKickoff";

const arr = (v) => { if (!v) return []; try { const p = JSON.parse(v); return Array.isArray(p) ? p : []; } catch { return []; } };
const obj = (v) => { if (!v) return null; try { return JSON.parse(v); } catch { return null; } };

export function parsePackageRow(row, { optionRows = [] } = {}) {
  if (!row) return null;
  const turnover = obj(row.TurnoverJson);
  if (!turnover) return null;
  const sections = arr(row.SectionsJson);
  const cache = obj(row.HubSpotCacheJson);

  // Layout 1 kept its §16 permits answers as JSON in that section's Notes.
  let permitsTerms = null;
  const permitsNum = sectionNumberOf(turnover, "permits");
  const permitsSec = permitsNum ? sections.find(s => s.SectionNumber === permitsNum) : null;
  const p = obj(permitsSec?.Notes);
  if (p && typeof p === "object" && "permits" in p) permitsTerms = p;

  return {
    turnover, sections,
    documents: arr(row.DocumentsJson),
    actionItems: arr(row.ActionItemsJson),
    schedule: arr(row.ScheduleJson),
    contractReview: arr(row.ContractReviewJson),
    contractIssues: arr(row.ContractIssuesJson),
    contractReviewItems: arr(row.ContractReviewItemsJson),
    contractRequirements: arr(row.ContractRequirementsJson),
    aiSummaries: arr(row.AISummariesJson),
    hsCompanies: cache ? arr(cache.CompaniesJson) : [],
    hsContacts: cache ? arr(cache.ContactsJson) : [],
    hsLineItems: cache ? arr(cache.LineItemsJson) : [],
    permitsTerms,
    marketingKickoff: normalizeKickoff(obj(row.MarketingKickoffJson)?.DataJson || null),
    optionRows,
  };
}

// Graph "shares" id for a SharePoint URL: u! + base64url of the URL.
export function shareIdForUrl(url) {
  const b64 = typeof btoa === "function"
    ? btoa(unescape(encodeURIComponent(String(url))))
    : Buffer.from(String(url), "utf8").toString("base64");
  return "u!" + b64.replace(/=+$/, "").replace(/\//g, "_").replace(/\+/g, "-");
}
